import { PRIMARY_BUTTON_BASE_CSS_VARS } from "@circle-react-shared/BuilderUI/SiteThemes/themes/base/Buttons/Primary";
import { SECONDARY_BUTTON_BASE_CSS_VARS } from "@circle-react-shared/BuilderUI/SiteThemes/themes/base/Buttons/Secondary";
import { TYPOGRAPHY_BASE_CSS_VARS } from "@circle-react-shared/BuilderUI/SiteThemes/themes/base/Typography";

export const defaultLightThemeVariables = {
  "theme-email-color-1": "#FFFFFF",
  "theme-email-color-2": "#F0F3FF",
  "theme-email-color-3": "#D0D2D8",
  "theme-email-color-4": "#071031",
  "theme-email-color-5": "#063CFF",
  "theme-email-color-6": "#0224A0",
} as const;

const baseLightThemeVariables = {
  ...defaultLightThemeVariables,
  "theme-email-color-background-primary":
    defaultLightThemeVariables["theme-email-color-1"],
  "theme-email-color-background-secondary":
    defaultLightThemeVariables["theme-email-color-2"],
  "theme-email-color-border": defaultLightThemeVariables["theme-email-color-3"],
  "theme-email-color-text-primary":
    defaultLightThemeVariables["theme-email-color-4"],
  "theme-email-color-text-secondary":
    defaultLightThemeVariables["theme-email-color-5"],
  "theme-email-color-text-link":
    defaultLightThemeVariables["theme-email-color-6"],
  "theme-email-color-text-muted": "#000000",
  "theme-email-color-border-primary": "#000000",
  "theme-email-color-border-highlight":
    defaultLightThemeVariables["theme-email-color-5"],
} as const;

export const defaultThemeVariables = {
  light: {
    ...baseLightThemeVariables,
  },
  p1: {
    "theme-email-p1-color-text":
      baseLightThemeVariables["theme-email-color-text-primary"],
    "theme-email-p1-font-family":
      TYPOGRAPHY_BASE_CSS_VARS.p1["theme-website-p1-font-family"],
    "theme-email-p1-font-weight":
      TYPOGRAPHY_BASE_CSS_VARS.p1["theme-website-p1-font-weight"],
    "theme-email-p1-font-size": "18px",
    "theme-email-p1-line-height":
      TYPOGRAPHY_BASE_CSS_VARS.p1["theme-website-p1-line-height"],
    "theme-email-p1-letter-spacing": "0px",
  },
  p2: {
    "theme-email-p2-color-text":
      baseLightThemeVariables["theme-email-color-text-secondary"],
    "theme-email-p2-font-family":
      TYPOGRAPHY_BASE_CSS_VARS.p2["theme-website-p2-font-family"],
    "theme-email-p2-font-weight":
      TYPOGRAPHY_BASE_CSS_VARS.p2["theme-website-p2-font-weight"],
    "theme-email-p2-font-size": "16px",
    "theme-email-p2-line-height":
      TYPOGRAPHY_BASE_CSS_VARS.p2["theme-website-p2-line-height"],
    "theme-email-p2-letter-spacing": "0px",
  },
  p3: {
    "theme-email-p3-color-text":
      baseLightThemeVariables["theme-email-color-text-muted"],
    "theme-email-p3-font-family":
      TYPOGRAPHY_BASE_CSS_VARS.p3["theme-website-p3-font-family"],
    "theme-email-p3-font-weight":
      TYPOGRAPHY_BASE_CSS_VARS.p3["theme-website-p3-font-weight"],
    "theme-email-p3-font-size": "14px",
    "theme-email-p3-line-height":
      TYPOGRAPHY_BASE_CSS_VARS.p3["theme-website-p3-line-height"],
    "theme-email-p3-letter-spacing": "0px",
  },
  primary_button: {
    "theme-email-primary-button-text-color":
      defaultLightThemeVariables["theme-email-color-1"],
    "theme-email-primary-button-border-color":
      defaultLightThemeVariables["theme-email-color-5"],
    "theme-email-primary-button-background-color":
      defaultLightThemeVariables["theme-email-color-5"],
    "theme-email-primary-button-font-weight":
      PRIMARY_BUTTON_BASE_CSS_VARS[
        "theme-website-primary-button-default-font-weight"
      ],
    "theme-email-primary-button-font-size": "16px",
    "theme-email-primary-button-letter-spacing": "-0.01px",
    "theme-email-primary-button-line-height":
      PRIMARY_BUTTON_BASE_CSS_VARS[
        "theme-website-primary-button-default-line-height"
      ],
    "theme-email-primary-button-padding-top":
      PRIMARY_BUTTON_BASE_CSS_VARS["theme-website-primary-button-padding-top"],
    "theme-email-primary-button-padding-bottom":
      PRIMARY_BUTTON_BASE_CSS_VARS[
        "theme-website-primary-button-padding-bottom"
      ],
    "theme-email-primary-button-padding-left":
      PRIMARY_BUTTON_BASE_CSS_VARS["theme-website-primary-button-padding-left"],
    "theme-email-primary-button-padding-right":
      PRIMARY_BUTTON_BASE_CSS_VARS[
        "theme-website-primary-button-padding-right"
      ],
    "theme-email-primary-button-shadow": "8",
    "theme-email-primary-button-border-left-top-radius": "8",
    "theme-email-primary-button-border-left-bottom-radius": "8",
    "theme-email-primary-button-border-right-top-radius": "8",
    "theme-email-primary-button-border-right-bottom-radius": "8",
    "theme-email-primary-button-border-width":
      PRIMARY_BUTTON_BASE_CSS_VARS[
        "theme-website-primary-button-default-border-width"
      ],
  },
  secondary_button: {
    "theme-email-secondary-button-text-color":
      defaultLightThemeVariables["theme-email-color-5"],
    "theme-email-secondary-button-border-color":
      defaultLightThemeVariables["theme-email-color-5"],
    "theme-email-secondary-button-background-color":
      defaultLightThemeVariables["theme-email-color-1"],
    "theme-email-secondary-button-font-weight":
      SECONDARY_BUTTON_BASE_CSS_VARS[
        "theme-website-secondary-button-default-font-weight"
      ],
    "theme-email-secondary-button-font-size": "16px",
    "theme-email-secondary-button-letter-spacing": "-0.01px",
    "theme-email-secondary-button-line-height":
      SECONDARY_BUTTON_BASE_CSS_VARS[
        "theme-website-secondary-button-default-line-height"
      ],
    "theme-email-secondary-button-padding-top":
      SECONDARY_BUTTON_BASE_CSS_VARS[
        "theme-website-secondary-button-padding-top"
      ],
    "theme-email-secondary-button-padding-bottom":
      SECONDARY_BUTTON_BASE_CSS_VARS[
        "theme-website-secondary-button-padding-bottom"
      ],
    "theme-email-secondary-button-padding-left":
      SECONDARY_BUTTON_BASE_CSS_VARS[
        "theme-website-secondary-button-padding-left"
      ],
    "theme-email-secondary-button-padding-right":
      SECONDARY_BUTTON_BASE_CSS_VARS[
        "theme-website-secondary-button-padding-right"
      ],
    "theme-email-secondary-button-shadow":
      SECONDARY_BUTTON_BASE_CSS_VARS[
        "theme-website-secondary-button-default-shadow"
      ],
    "theme-email-secondary-button-border-left-top-radius": "8",
    "theme-email-secondary-button-border-left-bottom-radius": "8",
    "theme-email-secondary-button-border-right-top-radius": "8",
    "theme-email-secondary-button-border-right-bottom-radius": "8",
    "theme-email-secondary-button-border-width":
      SECONDARY_BUTTON_BASE_CSS_VARS[
        "theme-website-secondary-button-default-border-width"
      ],
  },
  h1: {
    "theme-email-h1-color-text": "var(--theme-email-color-text-primary)",
    "theme-email-h1-font-family":
      TYPOGRAPHY_BASE_CSS_VARS.h1["theme-website-h1-font-family"],
    "theme-email-h1-font-weight":
      TYPOGRAPHY_BASE_CSS_VARS.h1["theme-website-h1-font-weight"],
    "theme-email-h1-font-size": "72px",
    "theme-email-h1-line-height":
      TYPOGRAPHY_BASE_CSS_VARS.h1["theme-website-h1-line-height"],
    "theme-email-h1-letter-spacing": "-1.24px",
  },
  h2: {
    "theme-email-h2-color-text":
      baseLightThemeVariables["theme-email-color-text-primary"],
    "theme-email-h2-font-family":
      TYPOGRAPHY_BASE_CSS_VARS.h2["theme-website-h2-font-family"],
    "theme-email-h2-font-weight":
      TYPOGRAPHY_BASE_CSS_VARS.h2["theme-website-h2-font-weight"],
    "theme-email-h2-font-size": "48px",
    "theme-email-h2-line-height":
      TYPOGRAPHY_BASE_CSS_VARS.h2["theme-website-h2-line-height"],
    "theme-email-h2-letter-spacing": "0px",
  },
  h3: {
    "theme-email-h3-color-text":
      baseLightThemeVariables["theme-email-color-text-primary"],
    "theme-email-h3-font-family":
      TYPOGRAPHY_BASE_CSS_VARS.h3["theme-website-h3-font-family"],
    "theme-email-h3-font-weight":
      TYPOGRAPHY_BASE_CSS_VARS.h3["theme-website-h3-font-weight"],
    "theme-email-h3-font-size": "38px",
    "theme-email-h3-line-height":
      TYPOGRAPHY_BASE_CSS_VARS.h3["theme-website-h3-line-height"],
    "theme-email-h3-letter-spacing": "0px",
  },
  h4: {
    "theme-email-h4-color-text":
      baseLightThemeVariables["theme-email-color-text-primary"],
    "theme-email-h4-font-family":
      TYPOGRAPHY_BASE_CSS_VARS.h4["theme-website-h4-font-family"],
    "theme-email-h4-font-weight":
      TYPOGRAPHY_BASE_CSS_VARS.h4["theme-website-h4-font-weight"],
    "theme-email-h4-font-size": "34px",
    "theme-email-h4-line-height":
      TYPOGRAPHY_BASE_CSS_VARS.h4["theme-website-h4-line-height"],
    "theme-email-h4-letter-spacing": "0px",
  },
  h5: {
    "theme-email-h5-color-text":
      baseLightThemeVariables["theme-email-color-text-primary"],
    "theme-email-h5-font-family":
      TYPOGRAPHY_BASE_CSS_VARS.h5["theme-website-h5-font-family"],
    "theme-email-h5-font-weight":
      TYPOGRAPHY_BASE_CSS_VARS.h5["theme-website-h5-font-weight"],
    "theme-email-h5-font-size": "28px",
    "theme-email-h5-line-height":
      TYPOGRAPHY_BASE_CSS_VARS.h5["theme-website-h5-line-height"],
    "theme-email-h5-letter-spacing": "0px",
  },
  h6: {
    "theme-email-h6-color-text":
      baseLightThemeVariables["theme-email-color-text-primary"],
    "theme-email-h6-font-family":
      TYPOGRAPHY_BASE_CSS_VARS.h6["theme-website-h6-font-family"],
    "theme-email-h6-font-weight":
      TYPOGRAPHY_BASE_CSS_VARS.h6["theme-website-h6-font-weight"],
    "theme-email-h6-font-size": "22px",
    "theme-email-h6-line-height":
      TYPOGRAPHY_BASE_CSS_VARS.h6["theme-website-h6-line-height"],
    "theme-email-h6-letter-spacing": "0px",
  },
};
